/**
 * 環境設定系（端末・ホスト・ブラウザの判定）
 */

export interface AppEnv {
  device: string
  ua: 'sp' | 'tab' | 'other'
  event: 'click'
  protocol: string
  http: string
  host: string
  root: string
  browser: 'ie' | 'edge' | 'chrome' | 'safari' | 'firefox' | 'opera' | 'other'
}

/**
 * 端末・ホスト・ブラウザの判定結果をまとめて返す
 */
export const getAppEnv = (): AppEnv => {
  //端末
    const device = navigator.userAgent
    let ua: AppEnv['ua'] = 'other'
    if(
        device.includes('iPhone')
        || device.includes('iPod')
        || (device.includes('Android') && device.includes('Mobile'))
    ){
        ua = 'sp'
    }
    else if(device.includes('iPad') || device.includes('Android')) {
        ua = 'tab'
    }

  //ホストによる root 変数設定
    const protocol = window.location.protocol
    const http = `${protocol}//`
    const host = location.host
    const hostMap: Record<string, string> = {
      'dev.lion-meishi.com': `${http}dev.lion-meishi.com`,
      'dev-xserver.lion-meishi.com': `${http}dev.lion-meishi.com`,
      'ore-no-nxg.lion-meishi.com': `${http}dev.lion-meishi.com`,
      'nxg.lion-meishi.com': `${http}nxg.lion-meishi.com`,
      'xserver.lion-meishi.com': `${http}www.lion-meishi.com`,
      'www.lion-meishi.com': `${http}www.lion-meishi.com`,
      'lion-meishi.com': `${http}www.lion-meishi.com`,
      'jichitai.lion-meishi.com': `${http}jichitai.lion-meishi.com`,
      'dev-jichitai.lion-meishi.com': `${http}dev-jichitai.lion-meishi.com`,
    }
    const root = hostMap[host] || `${http}${host}`

  //ブラウザ判定
    const deviceLower = device.toLowerCase()
    let browser: AppEnv['browser'] = 'other'
    if(deviceLower.includes('msie') || deviceLower.includes('trident')) browser = 'ie'
    else if(deviceLower.includes('edge')) browser = 'edge'
    else if(deviceLower.includes('chrome')) browser = 'chrome'
    else if(deviceLower.includes('safari')) browser = 'safari'
    else if(deviceLower.includes('firefox')) browser = 'firefox'
    else if(deviceLower.includes('opera')) browser = 'opera'

  //環境をまとめて返す
    return { device, ua, event: 'click', protocol, http, host, root, browser }
}
